// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import { EventType, PageClass } from '@portal/enum/analytics';
import { useCardsEnabled } from '@portal/hooks/useCard';
import useReduxState from '@portal/hooks/useReduxState';
import { tabRolesFilter } from '@portal/utils/rolesFilter';
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sendEvent } from '@portal/services/firebase';
import { sidebarRoutes } from '@portal/enum/sidebarRoutes';

export interface IProps {
  routes: models.Route[];
}

const PanelSidebarMenu: React.FC<IProps> = (props) => {
  const {
    user: { roles, cardEligibility },
    theme: { currentTheme },
  } = useReduxState();
  const location = useLocation();
  const cardsEnabled = useCardsEnabled(roles, cardEligibility);

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.SIDEBAR,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const buttonAnalyticsMenu = (name: string) => {
    switch (name) {
      case sidebarRoutes.HOME:
        sendEvent(EventType.HOME_BUTTON);
        break;
      case sidebarRoutes.PIX:
        sendEvent(EventType.HOME_PIX_BUTTON);
        break;
      case sidebarRoutes.TRANSFERS:
        sendEvent(EventType.HOME_TRANSFER_BUTTON);
        break;
      case sidebarRoutes.EXTRACT:
        sendEvent(EventType.HOME_TAB_EXTRACT_BUTTON);
        break;
      case sidebarRoutes.RECEIVABLE:
        sendEvent(EventType.HOME_RECEIVABLE_BUTTON);
        break;
      case sidebarRoutes.FILES_HANDLER:
      case sidebarRoutes.PAYABLE:
        sendEvent(EventType.HOME_PAYMENT_BUTTON);
        break;
      case sidebarRoutes.CASHBACK:
        sendEvent(EventType.HOME_CASHBACK_BUTTON);
        break;
      case sidebarRoutes.CARDS:
        sendEvent(EventType.HOME_TAB_CARDS_BUTTON);
        break;
      case sidebarRoutes.ESCROW:
        sendEvent(EventType.HOME_ESCROW_BUTTON);
        break;
      case sidebarRoutes.PROFILE:
        sendEvent(EventType.HOME_TAB_PROFILE_BUTTON);
        break;
      case sidebarRoutes.INVESTMENTS:
        sendEvent(EventType.HOME_INVESTMENTS_BUTTON);
        break;
      case sidebarRoutes.PAYLISP:
        sendEvent(EventType.HOME_PAYSLIP_BUTTON);
        break;

      default:
        break;
    }
  };

  const isActive = (path: string) => location.pathname.includes(path);
  return (
    <div className="panel-sidebar-menu">
      <div className="panel-sidebar-menu__items">
        {props.routes
          .filter((route) => !route.hidden)
          .filter((route) => tabRolesFilter(route, roles))
          .filter((route) =>
            route.id === sidebarRoutes.CARDS ? cardsEnabled : true
          )
          .map((route, index) => (
            <Link
              key={index.toString()}
              to={`${route.route}`}
              className={`
                panel-sidebar-menu__items__single__items__single__link ${
                  isActive(`${route.route}`)
                    ? 'panel-sidebar-menu__items__single__items__single__link--active'
                    : ''
                }
             `}
              style={
                isActive(route.route)
                  ? ({
                      borderLeft: `2px solid ${currentTheme.borderColor}`,
                    } as React.CSSProperties)
                  : {}
              }
            >
              <button
                {...{ testId: `home_${route.id}_click` }}
                className="panel-sidebar-menu__items__single"
                onClick={() => buttonAnalyticsMenu(route.id)}
              >
                <img
                  className="panel-sidebar-menu__items__single__icon"
                  src={route.icon}
                  alt={route.iconAlt}
                />
                <span
                  className="panel-sidebar-menu__items__single__title"
                  style={{
                    fontWeight: isActive(route.route) ? 'bold' : 100,
                  }}
                >
                  {route.name}
                </span>
              </button>
            </Link>
          ))}
      </div>
    </div>
  );
};

export default PanelSidebarMenu;
